/**
 * Server api configuration
 */

import Vue from 'vue'

const api = {}

export default api
api.timeout = { timeout: 20000 }
// api.serverURL = (location.hostname === 'clearassured.co.uk') ? 'https://api.clearassured.co.uk' : 'http://dev.api.clearassured.co.uk'
if (location.hostname === 'clearassured.co.uk') {
  api.serverURL = 'https://api.clearassured.co.uk'
} else if (location.hostname === 'dev.clearassured.co.uk') {
  api.serverURL = 'http://dev.api.clearassured.co.uk'
} else if (location.hostname === 'stage.clearassured.co.uk') {
  api.serverURL = 'https://api.stage.clearassured.co.uk'
} else if (location.hostname === 'live.clearassured.co.uk') {
  api.serverURL = 'https://api.live.clearassured.co.uk'
}
if (location.hostname === 'tcc-front.local') {
  api.serverURL = 'http://tcc-back.local'
}
if (location.hostname === 'tccfront.local') {
  api.serverURL = 'http://tccback.local'
}
if (location.hostname === 'localhost') {
  api.serverURL = 'http://localhost:8000'
}
if (location.hostname === '10.0.2.2') {
  api.serverURL = 'http://10.0.2.2:8000'
}

// api.serverURL = 'https://api.stage.clearassured.co.uk'

api.staticServerURL = api.serverURL

api.token = localStorage.getItem('token')
api.headersAuthSettings = { headers: localStorage.getItem('token') ? {'Authorization': `Bearer ${localStorage.getItem('token')}`} : '' }

api.serverContenImages = api.serverURL + '/uploads/images/content/'
api.serverUserImages = api.serverURL + '/uploads/images/users/'

api.URLS = {
  points: `${api.serverURL}/api/v1/point`,
  pointsAll: `${api.serverURL}/api/v1/points`,
  search: `${api.serverURL}/api/v1/search?_format=json`,
  login: `${api.serverURL}/oauth/v2/token`,
  userRoles: `/api/v1/getUserRoles/`,
  register: `${api.serverURL}/api/v1/register`,
  forgotPassword: `${api.serverURL}/resetting/send-email`,
  content: `${api.serverURL}/api/v1/content`,
  contentNew: `${api.serverURL}/api/v1/content-front`,
  contentTypes: '/api/v1/contentTypes',
  contentChapters: '/api/v1/chapters',
  contentChaptersList: `${api.serverURL}/api/v1/chapters`,
  contentType: `${api.serverURL}/api/v1/contentType/`,
  contentSearch: `${api.serverURL}/api/v1/content-search`,
  companiesS: `${api.serverURL}/api/v1/company`,
  companies: `/api/v1/company`,
  companyList: `${api.serverURL}/api/v1/company`,
  tags: '/api/v1/tags',
  tagsSimple: '/api/v1/tags-simple',
  tags1: `${api.serverURL}/api/v1/tags`,
  tag: `${api.serverURL}/api/v1/tag`,
  categories: '/api/v1/categories',
  categories1: `${api.serverURL}/api/v1/categories`,
  chapters: `${api.serverURL}/api/v1/chapters`,
  category: `${api.serverURL}/api/v1/category`,
  chapter: `${api.serverURL}/api/v1/chapter`,
  actionsURLS: {
    actions: '/api/v1/get-actions',
    permissions: `/api/v1/permissions`,
    disallowed: `${api.serverURL}/api/v1/disallowed`
  },
  roles: `/api/v1/roles`,
  user: `${api.serverURL}/api/v1/user`,
  users: `${api.serverURL}/api/v1/users`,
  usersSearch: `${api.serverURL}/api/v1/user-search`,
  languages: '/api/v1/language',
  enabled: `${api.serverURL}/api/v1/enabled`,
  createAdmin: `${api.serverURL}/api/v1/register-admin/`,
  changeStatus: `${api.serverURL}/api/v1/change-status`,
  changeDoneStatus: `${api.serverURL}/api/v1/change-done-status`,
  deleteStatus: `${api.serverURL}/api/v1/delete-done-status-message`,
  getDoneStatus: `${api.serverURL}/api/v1/contentstatuses`,
  profile: `${api.serverURL}/api/v1/profile`,
  userLastLogin: `${api.serverURL}/api/v1/user-last-login/`,
  articleLog: `${api.serverURL}/api/v1/get-log-data/`,
  resetPassword: `${api.serverURL}/resetting/reset/`,
  invalidToken: `${api.serverURL}/token/`,
  page: `${api.serverURL}/api/v1/page-list`,
  password: `${api.serverURL}/api/v1/password-change`,
  companyCreate: `${api.serverURL}/api/v1/company-create`,
  companyPoints: `${api.serverURL}/api/v1/companypoints`,
  industry: `${api.serverURL}/api/v1/industry`,
  industries: `/api/v1/industries`,
  industryList: `${api.serverURL}/api/v1/industries`,
  sponsors: `${api.serverURL}/api/v1/sponsorsbyindustry`,
  sponsorsByLanding: `${api.serverURL}/api/v1/sponsorsbyindustrylanding`,
  contentByCompany: `${api.serverURL}/api/v1/contentbycompany`,
  staticpage: `${api.serverURL}/api/v1/staticpage`,
  staticpagechanges: `${api.serverURL}/api/v1/staticpagechanges`,
  brochureRequest: `${api.serverURL}/api/v1/request-brochure`,
  contactSubmit: `${api.serverURL}/api/v1/contact`,
  searchSave: `${api.serverURL}/api/v1/searchsave`,
  dashboardCounters: `${api.serverURL}/api/v1/dashboardcounters`,
  topZeroSearch: `${api.serverURL}/api/v1/topzerosearch`,
  topSearch: `${api.serverURL}/api/v1/topsearch`,
  logs: `${api.serverURL}/api/v1/logs`,
  consent: `${api.serverURL}/api/v1/consentlogs`,
  consentDownload: `${api.serverURL}/api/v1/consentlogs-download`,
  filterLogs: `${api.serverURL}/api/v1/filter/logs`,
  consentLogs: `${api.serverURL}/api/v1/filter/consentlogs`,
  filterLogCompanies: `${api.serverURL}/api/v1/filter/companies`,
  filterLogUsers: `${api.serverURL}/api/v1/filter/users`,
  filterMailTypes: `${api.serverURL}/api/v1/filter/mails`,
  userNotifications: `${api.serverURL}/api/v1/user/notifications`,
  userNotificationsRead: `${api.serverURL}/api/v1/user/readnotifications`,
  inviteUsers: `${api.serverURL}/api/v1/invite-users`,
  activateUser: `${api.serverURL}/api/v1/activate/user/`,
  activatePassword: `${api.serverURL}/api/v1/activate/password/`,
  seenConsent: `${api.serverURL}/api/v1/consent/seen`,
  updateConsent: `${api.serverURL}/api/v1/consent/update`,
  companyPublic: `${api.serverURL}/api/v1/companypublic`,
  userStatuses: `${api.serverURL}/api/v1/userstatuses`,
  emailLogs: `${api.serverURL}/api/v1/emaillogs`,
  emailSingle: `${api.serverURL}/api/v1/emaillog`,
  mailTypes: `${api.serverURL}/api/v1/filter/mailstypes`,
  mailStatuses: `${api.serverURL}/api/v1/filter/mailstatuses`,
  checkSubscribe: `${api.serverURL}/api/v1/issubscribe`,
  subscribe: `${api.serverURL}/api/v1/subscribe`,
  subscription: `${api.serverURL}/api/v1/subscription`,
  subscribeConfirm: `${api.serverURL}/api/v1/subscribeconfirm`,
  unSubscribe: `${api.serverURL}/api/v1/un-subscribe`,
  uploadFile: `${api.serverURL}/api/v1/upload-file`,
  tawkHash: `${api.serverURL}/api/v1/tawk/hash`,
  emailTemplate: `${api.serverURL}/api/v1/email-template`,
  emailPreferences: `${api.serverURL}/api/v1/email-preferences`,
  disabledEmails: `${api.serverURL}/api/v1/disabled-emails`,
  promotions: `${api.serverURL}/api/v1/promotions`,
  defaultRegistrationRoles: `/api/v1/default-registration-roles`,
  testEmail: `${api.serverURL}/api/v1/test-email-template`,
  redirect: `${api.serverURL}/api/v1/redirect`,
  task: `${api.serverURL}/api/v1/task`,
  taskNoBase: `/api/v1/task`,
  adminUsers: `/api/v1/admin-users`,
  file: `/api/v1/admin-users`,
  topicSuggest: `${api.serverURL}/api/v1/suggest-topic`,
  contentLatest: `${api.serverURL}/api/v1/content-latest`,
  companySizes: `/api/v1/company/sizes`,
  companyLocations: `/api/v1/company/locations`
}
api.requestToServer = (urlEnd, type, payload = api.headersAuthSettings) => Vue.http[type](api.serverURL + urlEnd, payload, api.timeout)



// WEBPACK FOOTER //
// ./src/api/index.js